export const COLORS = {
    primary: '#000a8c',
    light: '#5992ed',
    dark: '#000762'
}